import { tagsQueries } from 'tags/utils/queries';
import { useTagsContext } from './useTagsContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Tag } from 'tags/models/tags';

export const useAssignedTags = (cardId: string, enabled: boolean) => {
  const { type, fetchAssignedTags } = useTagsContext();
  const query = useQuery({
    queryKey: tagsQueries.assigned(type, cardId),
    queryFn: async () => {
      const tags = await fetchAssignedTags(cardId);
      return tags;
    },
    enabled,
    initialData: [],
  });

  const queryClient = useQueryClient();
  const appendAssignedTagsLocally = (tags: Tag[]) => {
    queryClient.setQueryData<Tag[]>(tagsQueries.assigned(type, cardId), (currentSelectedTags) => {
      if (!currentSelectedTags) {
        return [...tags];
      }

      return [...currentSelectedTags, ...tags];
    });
  };

  const replaceAssignedTagsLocally = (tags: Tag[]) => {
    return queryClient.setQueryData<Tag[]>(tagsQueries.assigned(type, cardId), tags);
  };

  return {
    ...query,
    replaceAssignedTagsLocally,
    appendAssignedTagsLocally,
  };
};
